import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import type { CurrentUser } from "@thalamos/haven-common";

import { useUser } from "../../Context/UserContext.js";

/**
 * Whether the session is acting as an organisation's admin. Decides only what to
 * render: the server refuses every request behind it from anybody else.
 */
const isActingAsOrganisationAdmin = (user: CurrentUser | undefined): boolean =>
  user?.sessionContext?.kind === "organisation_administration";

/** The accounts an organisation's admin manages, refused to every other session. */
export const OrganisationUsersShell = () => {
  const { user } = useUser();

  return <OrganisationUsersShellContent user={user} />;
};

export const OrganisationUsersShellContent = ({
  user,
}: {
  user: CurrentUser | undefined;
}) => {
  const { t } = useTranslation();

  return isActingAsOrganisationAdmin(user) ? (
    <Outlet />
  ) : (
    <Typography variant="body1">
      {t("admin.users.notAnOrganisationAdmin")}
    </Typography>
  );
};
